import { GQLResponsePerimeterXChallengeError } from '@change-corgi/core/gql';
import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import { CANCELLATION_SOURCE_ACCOUNT_SETTINGS } from '#src/app/shared/constants';

import {
	CancelSubscription,
	type CancelSubscriptionMutation,
	type CancelSubscriptionMutationVariables,
} from './cancelSubscription.graphql';

export type CancelSubscriptionResult = {
	success: boolean;
};

export async function cancelSubscriptionApi(
	{ subscriptionId }: { subscriptionId: string },
	{ errorReporter, gql: { fetch } }: UtilityContext,
): Promise<CancelSubscriptionResult> {
	try {
		const { data } = await fetch<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>({
			query: CancelSubscription,
			variables: { input: { id: subscriptionId, cancellationSource: CANCELLATION_SOURCE_ACCOUNT_SETTINGS } },
			path: '/payments/cancelSubscription',
			batched: false, // to ensure this rate limited mutation is not batched
			rejectOnError: true,
		});
		if (data.cancelSubscription.result !== 'SUCCESS') {
			void errorReporter.report({ error: new Error('Failed to cancel subscription') }, { severity: 'info' });
			return { success: false };
		}
		return {
			success: true,
		};
	} catch (e) {
		if (e instanceof GQLResponsePerimeterXChallengeError) throw e;
		return { success: false };
	}
}
